import '../../base_builders/vertical/rcp/rcp_base_vendor_builder.js';

import toastr from 'toastr';
window.toastr = toastr;

import Chartbeat from '../../../assets/js/Analytics/Chartbeat.js';
Chartbeat();

import  {init_taboola_home} from '../../../assets/js/Ads/TaboolaLib.js';
init_taboola_home();